export const formDefaults = {
  programmedUnactivate: false,
  isUpdate: false,
  active: false,
}
